import { brandColors } from "@/lib/brandColors"
import { cn } from "@/lib/utils"

interface LoadingSpinnerProps {
  size?: string | number
  color?: string
  className?: string
}

// Same geometry and motion as the MUI CircularProgress this replaced: a
// 3.6-unit ring in a 44-unit viewBox, turning while its dash grows and shrinks
// (the spinner-* animations in src/index.css).
const VIEWBOX_SIZE = 44
const THICKNESS = 3.6

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 40,
  color = brandColors.yellow2,
  className,
}) => (
  <span
    role="progressbar"
    className={cn("inline-block animate-spinner-rotate", className)}
    style={{ width: size, height: size, color }}
  >
    <svg
      className="block"
      viewBox={`${VIEWBOX_SIZE / 2} ${VIEWBOX_SIZE / 2} ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
    >
      <circle
        className="animate-spinner-dash"
        style={{ strokeDasharray: "80px, 200px", strokeDashoffset: 0 }}
        cx={VIEWBOX_SIZE}
        cy={VIEWBOX_SIZE}
        r={(VIEWBOX_SIZE - THICKNESS) / 2}
        fill="none"
        stroke="currentColor"
        strokeWidth={THICKNESS}
      />
    </svg>
  </span>
)
